// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__j3IbB","filesListContainer":"PosDisputesFiles_filesListContainer__1ICpr","filesButton":"PosDisputesFiles_filesButton__1ibTU"};